import { render, staticRenderFns } from "./ChecksDetails.vue?vue&type=template&id=28a7f454&"
import script from "./ChecksDetails.vue?vue&type=script&lang=js&"
export * from "./ChecksDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports